import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  addMasterSpeedLearnAsync,
  getAllMasterSpeedLearnAsync,
  getMasterSpeedLearnByIdAsync,
  updateMasterSpeedLearnAsync,
  deleteMasterSpeedLearnAsync,
} from "./masterspeedlearn.async";

const initialState = {
  speedLearnMasterLoader: false,
  addMasterSpeedLearn: [],
  getAllSpeedLearn: [],
  getSpeedLearnById: [],
  updateSpeedLearn: [],
  speedLearnMasterDelete: [],
};

export const speedLearnMasterSlice = createSlice({
  name: "speedLearn",
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getAllMasterSpeedLearnAsync.pending,
        addMasterSpeedLearnAsync.pending,
        getMasterSpeedLearnByIdAsync.pending,
        updateMasterSpeedLearnAsync.pending,
        deleteMasterSpeedLearnAsync.pending
      ),
      (state) => {
        state.speedLearnMasterLoader = true;
      }
    );

    builder.addMatcher(
      isAnyOf(getAllMasterSpeedLearnAsync.fulfilled),
      (state, action) => {
        state.speedLearnMasterLoader = false;
        state.getAllSpeedLearn = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(addMasterSpeedLearnAsync.fulfilled),
      (state, action) => {
        state.speedLearnMasterLoader = false;
        state.addMasterSpeedLearn = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(getMasterSpeedLearnByIdAsync.fulfilled),
      (state, action) => {
        state.speedLearnMasterLoader = false;
        state.getSpeedLearnById = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(deleteMasterSpeedLearnAsync.fulfilled),
      (state, action) => {
        state.speedLearnMasterLoader = false;
        state.speedLearnMasterDelete = action.payload;
      }
    );
    builder.addMatcher(
      isAnyOf(updateMasterSpeedLearnAsync.fulfilled),
      (state, action) => {
        state.speedLearnMasterLoader = false;
        state.updateSpeedLearn = action.payload;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getAllMasterSpeedLearnAsync.rejected,
        addMasterSpeedLearnAsync.rejected,
        getMasterSpeedLearnByIdAsync.rejected,
        updateMasterSpeedLearnAsync.rejected,
        deleteMasterSpeedLearnAsync.rejected
      ),
      (state, action) => {
        state.speedLearnMasterLoader = false;
      }
    );
  },
  reducers: {
    emptySpeedLearnMaster: (state) => initialState,
  },
});

export const { emptySpeedLearnMaster } = speedLearnMasterSlice.actions;

export default speedLearnMasterSlice.reducer;
